<template>
    <div>
        <el-button color="#4F46E5" @click="choosetag" type="primary"  >选择标签</el-button>
        <div style="margin-top: 5px;">
            <el-tag
            closable
            class="t_choosedtag"  v-for="(item,index) in choosedtag.data" :key="index"
            @close="handleClose(item,index)"
            type="success">{{item.tag_name}}
            </el-tag>
        </div>
    </div>
    <!-- 选择标签 -->
    <el-dialog v-model="isqdtag" title="选择渠道标签" width="1200px" >
        <div class="t_tagchoose_box" v-for="(item,index) in bqData.data" :key="index">
            <div>{{item.cate_name}}</div>
            <div>
                <el-check-tag v-for="(item2,index2) in item.tags" :key="index2" 
                class="t_all_tag"
                :checked="item2.checked" @change="onChange(index,index2)">{{item2.tag_name}}</el-check-tag>
            </div>
        </div>
        <div class="t_cz_box">
            <el-button color="#4F46E5" @click="choosesub" type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'

//动态获取接口地址
const _url2 = inject('_url2')

//接受父级数组
const {choosedtag,bqData} = defineProps(['choosedtag','bqData'])
const emits = defineEmits()


//选择渠道标签弹窗
const isqdtag = ref(false)
const choosetag = ()=>{
    isqdtag.value=true
}



//切换标签选中事件
const onChange = (i1,i2)=>{
    bqData.data[i1].tags[i2].checked=!bqData.data[i1].tags[i2].checked
    //将数据传给父级
    emits('changebqData',bqData.data)
}
//确定选择
const choosesub = ()=>{
    isqdtag.value=false
    choosedtag.data=[]
    for(var i=0;i<bqData.data.length;i++){
        for(var x=0;x<bqData.data[i].tags.length;x++){
            if(bqData.data[i].tags[x].checked){
                choosedtag.data.push(bqData.data[i].tags[x])
            }
        }
    }
    console.log(choosedtag.data)
    //将数据传给父级
    emits('changechoosedtag',choosedtag.data)
    //将数据传给父级
    emits('changebqData',bqData.data)
}
//删除选中标签
const handleClose = (item,index)=>{
    console.log(item)
    choosedtag.data.splice(index, 1)
    //将数据传给父级
    emits('changechoosedtag',choosedtag.data)
    //将选中状态修改为未选中状态
    for(var i=0;i<bqData.data.length;i++){
        //找到父级
        if(bqData.data[i].id==item.tag_group_id){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                //找到子集
                if(bqData.data[i].tags[x].id==item.id){
                    //改为未选中
                    bqData.data[i].tags[x].checked=false
                }
            }
        }
        
    }
    //将数据传给父级
    emits('changebqData',bqData.data)
}

// watch(copybq, (newVal, oldVal) => {
   
//             console.log('copy标签')
//             console.log(newVal)
// })
</script>
<style scoped>
 .t_choosedtag{
    margin-right:10px;
    margin-bottom:20px;
    
  }
  .t_tagchoose_box{
    margin-bottom:30px
  }
  .t_all_tag{
    margin-top: 10px;
    margin-right: 10px;
  }
 
</style>